export function Sidebar({ business, view, onNav, owedCount }) {
  const items = [
    { id: 'home',     icon: '🏠', label: 'Home' },
    { id: 'parties',  icon: '👥', label: 'Parties', badge: null },
    { id: 'cashbook', icon: '📒', label: 'Cashbook' },
    { id: 'reports',  icon: '📊', label: 'Reports' },
    { id: 'settings', icon: '⚙️', label: 'Settings' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="brand-icon">📒</div>
        <div>
          <div className="brand-text">Cashbook</div>
          <div className="brand-sub">BAHI KHATA</div>
        </div>
      </div>

      {business && (
        <div className="biz-info">
          <div className="biz-name">🏪 {business.name}</div>
          {business.phone && <div className="biz-phone">📞 {business.phone}</div>}
        </div>
      )}

      <nav className="nav">
        {items.map(item => (
          <button key={item.id} className={`nav-item${view === item.id ? ' active' : ''}`}
            onClick={() => onNav(item.id)}>
            <span className="nav-icon">{item.icon}</span>
            {item.label}
            {item.id === 'parties' && owedCount > 0 && (
              <span className="nav-badge">{owedCount}</span>
            )}
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button className="sidebar-footer-btn">
          <span>📤</span> Share / Export
        </button>
      </div>
    </aside>
  );
}
